"use client";

import FeatureItem from "./FeatureItem";

export default function FeatureItemsBlock({ slice }) {
  return (
    <div className="lg:flex">
      {slice.primary?.feature_items.map((item, idx) => {
        return (
          <FeatureItem key={`feature_1_${idx}`} data={item} slice={slice} />
        );
      })}
    </div>
  );
}
